import { useCallback } from "react";

import { DisplayUser } from "../types";
import useAccount from "./useAccount";
import useTranslation from "./useTranslation";

export const useUserName = () => {
  const { t, m } = useTranslation();
  const { data: accountData } = useAccount();

  const getUserName = useCallback(
    (user?: DisplayUser, fallback?: string) => {
      const isCurrentUser = Boolean(user && accountData?.id === user.userId);

      if (isCurrentUser && !user?.name && !user?.email) {
        return t(m.General.You);
      }

      const displayValue = user?.name ?? user?.email ?? fallback;

      if (isCurrentUser && displayValue) {
        return t(m.General.NameWithYou, { name: displayValue });
      }

      return displayValue;
    },
    [accountData, t, m]
  );

  const getInitials = useCallback(
    (user?: DisplayUser) => {
      const isCurrentUser = Boolean(user && accountData?.id === user.userId);
      const value =
        user?.name?.trim() ||
        user?.email?.trim() ||
        (isCurrentUser ? accountData?.name?.trim() || accountData?.email?.trim() : undefined);
      return value?.[0]?.toUpperCase();
    },
    [accountData?.id, accountData?.name, accountData?.email]
  );

  return { getUserName, getInitials };
};
